import type { SVGProps } from "react";
export const ErrorTriangleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 14"
    className="fill-current"
    {...props}
  >
    <path
      fill="#F1005D"
      d="M8.25.138a1.32 1.32 0 0 1 1.141.658l6.402 11.09a1.32 1.32 0 0 1-1.141 1.976H1.848a1.32 1.32 0 0 1-1.141-1.977L7.11.796A1.32 1.32 0 0 1 8.25.138m0 10.293a.828.828 0 1 0 0 1.656.828.828 0 0 0 0-1.656m-.084-6.215a.745.745 0 0 0-.744.745V8.52c0 .411.333.744.744.744h.168a.745.745 0 0 0 .745-.744V4.961a.746.746 0 0 0-.745-.745z"
    />
  </svg>
);
